const rippleEffect = (item: HTMLElement, event: MouseEvent) => {
  if (!item || !event) return false;

  const ripple = document.createElement("span");
  ripple.classList.add("ripple");

  const max = Math.max(item.offsetWidth, item.offsetHeight);

  ripple.style.width = ripple.style.height = max * 2 + "px";

  const rect = item.getBoundingClientRect();

  ripple.style.left = event.clientX - rect.left - max + "px";
  ripple.style.top = event.clientY - rect.top - max + "px";

  item.appendChild(ripple);

  setTimeout(() => {
    ripple.remove();
  }, 900);
};

export {
  rippleEffect
}
